<template>
  <v-container class="my-5">
    <h2 class="subheading grey--text">Información General - Casa Club</h2>

    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>

    <v-layout row wrap class="mt-4">
      <v-flex xs12 md6>
        <v-card class="mb-4" outlined>
          <v-card-title class="primary--text">Información General</v-card-title>
          <v-card-text>
            <p><strong>Nombre:</strong> {{ clubInfo.name || 'N/A' }}</p>
            <p><strong>Fundación:</strong> {{ clubInfo.founded_date || 'N/A' }}</p>
            <p><strong>Ubicación:</strong> {{ clubInfo.location || 'N/A' }}</p>
            <p><strong>Director:</strong> {{ clubInfo.director || 'N/A' }}</p>
            <p><strong>Teléfono:</strong> {{ clubInfo.phone || 'N/A' }}</p>
            <p><strong>Email:</strong> {{ clubInfo.email || 'N/A' }}</p>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 md6>
        <v-card class="mb-4" outlined>
          <v-card-title class="primary--text">Estadísticas</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs6 class="pa-2">
                <div class="text-center">
                  <p class="display-1 primary--text">{{ clubInfo.active_members || 0 }}</p>
                  <p class="caption">Miembros Activos</p>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-2">
                <div class="text-center">
                  <p class="display-1 primary--text">{{ clubInfo.annual_tournaments || 0 }}</p>
                  <p class="caption">Torneos Anuales</p>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-2">
                <div class="text-center">
                  <p class="display-1 primary--text">{{ clubInfo.social_events || 0 }}</p>
                  <p class="caption">Eventos Sociales</p>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-2">
                <div class="text-center">
                  <p class="display-1 primary--text">{{ clubInfo.occupancy || '0%' }}</p>
                  <p class="caption">Ocupación</p>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card outlined>
          <v-card-title class="primary--text">Horario de Funcionamiento</v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <p><strong>Lunes a Viernes:</strong> {{ clubInfo.weekday_hours || 'N/A' }}</p>
                <p><strong>Sábado:</strong> {{ clubInfo.saturday_hours || 'N/A' }}</p>
              </v-flex>
              <v-flex xs12 sm6>
                <p><strong>Domingo:</strong> {{ clubInfo.sunday_hours || 'N/A' }}</p>
                <p><strong>Festivos:</strong> {{ clubInfo.holiday_hours || 'N/A' }}</p>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import clubHouseService from '@/services/clubHouseService'

export default {
  name: 'ClubHouseInfo',
  data () {
    return {
      loading: false,
      clubInfo: {
        name: '',
        founded_date: '',
        location: '',
        director: '',
        phone: '',
        email: '',
        active_members: 0,
        annual_tournaments: 0,
        social_events: 0,
        occupancy: '0%',
        weekday_hours: '',
        saturday_hours: '',
        sunday_hours: '',
        holiday_hours: ''
      }
    }
  },
  async mounted () {
    await this.fetchClubInfo()
  },
  methods: {
    async fetchClubInfo () {
      this.loading = true
      try {
        const response = await clubHouseService.getClubInfo()
        const data = response.data || response || {}
        this.clubInfo = {
          name: data.name || '',
          founded_date: data.founded_date || '',
          location: data.location || '',
          director: data.director || '',
          phone: data.phone || '',
          email: data.email || '',
          active_members: data.active_members || 0,
          annual_tournaments: data.annual_tournaments || 0,
          social_events: data.social_events || 0,
          occupancy: data.occupancy || '0%',
          weekday_hours: data.weekday_hours || '',
          saturday_hours: data.saturday_hours || '',
          sunday_hours: data.sunday_hours || '',
          holiday_hours: data.holiday_hours || ''
        }
      } catch (error) {
        console.error('Error loading club info:', error)
        this.$notify({
          message: 'Error al cargar la información de la Casa Club',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
</style>
